/* eslint-disable quotes */
import React, { useEffect } from 'react';
import PDFObject from 'pdfobject';
import makeStyles from '@mui/styles/makeStyles';
import { Button, Typography } from '@mui/material';
import { useTranslation } from 'utils/translation';
import { Theme } from '../../theme';
import { ModalClose } from '../index';
import clsx from 'clsx';

interface Props {
  className?: string;
  url: string;
  onClose(): void;
  loader?: any;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: theme.palette.background.paper,
  },
  fallback: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    margin: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(4),
    },
  },
  title: {
    margin: theme.spacing(3, 0),
    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(4, 0),
    },
  },
}));

const Fallback: React.FC<Props> = ({ url, onClose }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div className={classes.fallback}>
      <ModalClose onClose={onClose} />
      <Typography variant="h4" align="center" className={classes.title}>
        {t("Your browser doesn't support PDF previews")}
      </Typography>
      <Button color="primary" variant="outlined" href={url}>
        {t('Download')}
      </Button>
    </div>
  );
};

const PDFViewer: React.FC<Props> = ({ className, url, onClose }) => {
  const classes = useStyles();
  const isSupported = PDFObject.supportsPDFs;

  useEffect(() => {
    if (isSupported) {
      PDFObject.embed(url, '#pdf-preview-container');
    }
  }, [url, isSupported]);

  return (
    <div className={clsx(classes.root, className)} id="pdf-preview-container">
      {!isSupported && <Fallback url={url} onClose={onClose} />}
    </div>
  );
};

export default PDFViewer;
